import classNames from 'classnames';
import { Info } from 'react-feather';
var Label = function (_a) {
    var label = _a.label, htmlFor = _a.htmlFor, className = _a.className, required = _a.required, _b = _a.big, big = _b === void 0 ? false : _b, _c = _a.tooltip, tooltip = _c === void 0 ? false : _c, onTooltipClick = _a.onTooltipClick;
    var handleTooltipClick = function () {
        onTooltipClick && onTooltipClick();
    };
    return (<label htmlFor={htmlFor} className={classNames('mb-1 flex items-center gap-1 text-sm font-medium text-gray-900', big && 'text-lg', className)}>
      {label}
      {!required && <span className="font-normal text-gray-500"> (facultatif)</span>}
      {tooltip && (<Info size={20} className="cursor-pointer px-1 text-gray-500" onClick={handleTooltipClick}/>)}
    </label>);
};
export default Label;
